import { createMuiStyles } from '../../../../utils/mui';

export const featuredProgramsStyles = createMuiStyles({
  container: {
    pt: 2.5,
    pb: 5,
    mt: 5,
    bgcolor: 'primary.main',
    borderTopRightRadius: '25rem',
  },
  illustration: {
    display: 'block',
    height: '15rem',
    width: 'auto',
    overflow: 'visible',
    mt: -7.5,
  },
  sliderContainer: {
    '.featuredProgramsSlider': {
      px: 'var(--container-fluid-padding)',
    },
    '.swiper-slide': {
      height: 'auto',
    },
  },
  findMoreBtn: {
    float: 'right',
    mt: 1,
    bgcolor: 'common.white',
    '&:hover, &:focus, &:active': {
      bgcolor: 'primary.light',
    },
  },
});
